// APP-1487 (doc-security-market-data-01a150c533210e70): the empty values of
// FastTrack, shared by the market-data panels and the share-class flags.

/** The text in the place of an empty value (R15, R40). */
export const NOT_AVAILABLE = "Not available from FastTrack";

/**
 * FastTrack's empty values: null, "", "NA", "N/A", "-" and -999 (D5). A
 * string -999 counts too, also as a percent ("-999.00%").
 */
export function isEmptyValue(value: unknown): boolean {
  if (value === null || value === undefined) return true;
  if (typeof value === "number") return value === -999;
  if (typeof value !== "string") return false;
  const text = value.trim();
  if (["", "NA", "N/A", "-"].includes(text.toUpperCase())) return true;
  return /^-999(\.0+)?%?$/.test(text);
}
